<template src="./template.html"></template>

<script>
import poleMasterApi from '@/api/poleMaster'
import poleApi from '@/api/pole'
import kilopostApi from '@/api/kilopost'
import kilopostMixin from '@/mixin/kilopostMixin'
import streamMixin from '@/mixin/streamMixin'
import Stream from '@/lib/Stream'
import * as EVT from '@/consts/eventNames'

export default {
  name: 'pole-touroku',
  data() {
    return {
      // data
      // child group1
      allPoles: [],
      poleMap: {},
      filteredPoles: [], // for poleList
      displayedPoles: [], // for ExtremeMap
      focusAreaGeom: null,
      // child group2
      poleMasters: [],

      // kps
      kilopostsByRoadNameShort: {},
      displayedKiloposts: [], // for ExtremeMap

      // stream
      // child group1
      poleListStream: new Stream({ name: 'poleList', debug: false }),
      extremeMapStream: new Stream({ name: 'extremeMap', debug: false }),
      listWrapStream: new Stream({ name: 'listWrap', debug: false }),
      // child group2
      poleMasterListStream: new Stream({ name: 'poleMasterList', debug: false }),
      // me
      mainStream: new Stream({ name: 'main', debug: false }),

      // alert
      alert: {
        msg: '更新しました',
        variant: 'info',
        countDown: 0,
      },

      // SET_FOCUS_AREAを受け取った後に実行するやつ
      postSetFocusAreaFunc: null,

      confirmAttachChangeModalInfo: null,
      confirmDetachModalInfo: null,
    }
  },
  mounted() {
    const usedPoleMap = {}
    const p1 = poleApi.index().then(({ data }) => {
      this.allPoles = data
      this.filteredPoles = this.allPoles
      this.poleMap = {}
      for (const e of this.allPoles) {
        e.point = JSON.parse(e.point)

        this.poleMap[e.id] = e
        if (e.pole_number) {
          usedPoleMap[e.pole_number] = e.id
        }
      }
      // 全体だと地図が重いので.
      this.onSetFocusArea({ geom: this.focusAreaGeom })
    })
    const p2 = poleMasterApi.index()
    Promise.all([p1, p2]).then(([r1, r2]) => {
      const poleMasters = r2.data
      for (const pm of poleMasters) {
        const poleId = usedPoleMap[pm.pole_number]
        pm.is_attached = !!poleId
        pm.attached_pole_id = poleId
      }
      this.poleMasters = poleMasters
    })

    kilopostApi.index().then(({ data }) => {
      this.kilopostsByRoadNameShort = this.convKiloposts(data)
    })

    this.chainEvents()
    this.setListeners()
  },
  mixins: [streamMixin, kilopostMixin],
  methods: {
    chainEvents() {
      const extremeMap = this.extremeMapStream
      const poleList = this.poleListStream
      const listWrap = this.listWrapStream
      const poleMasterList = this.poleMasterListStream
      const main = this.mainStream

      poleList.chain([EVT.SELECT_POLES, EVT.UNSELECT_POLES])
        .to(extremeMap).end()
      extremeMap.chain([EVT.SELECT_POLES, EVT.UNSELECT_POLES])
        .to(poleList).end()
      listWrap.drain(
        [EVT.SELECT_POLES, EVT.UNSELECT_POLES],
        [poleList, extremeMap],
        {
          mapper: obj => {
            const poles = obj.ids.map(id => this.poleMap[id])
            return { poles }
          }
        }
      ).to(poleMasterList).end()

      listWrap.drain(EVT.CHANGE_POLES, poleList)
        .to(main).end()
      listWrap.drain([EVT.SET_FOCUS_AREA, EVT.UNSET_FOCUS_AREA], extremeMap)
        .to(main).end()

      poleMasterList.chain([
        EVT.SELECT_POLE_MASTERS,
        EVT.UNSELECT_POLE_MASTERS,
        EVT.CHANGE_ROAD_NAME,
      ]).to(main).end()

      main.chain(EVT.UPDATED_POLE_MASTERS).to(poleMasterList).end()

      main.connectOutOut(EVT.UPDATED_POLES, listWrap)
      listWrap.spread(EVT.UPDATED_POLES, [extremeMap, poleList])

      main.connectOutOut(EVT.SELECT_POLES_REV, listWrap)
      listWrap.spread(EVT.SELECT_POLES_REV,
        [extremeMap, poleList],
        {
          mapper: obj => {
            const ids = obj.poleMasters.map(e => e.attached_pole_id)
            return { ids }
          },
          outEventNames: [EVT.SELECT_POLES]
        }
      )
      main.chain(EVT.SET_ROAD_NAME).to(listWrap).to(extremeMap).end()
    },
    setListeners() {
      this.mainStream.recv(EVT.SELECT_POLE_MASTERS,
        (obj) => {
          if (!obj.poles || obj.poles.length === 0) {
            // ポールが選択されてない状態でマスタが選択された場合は
            // ポールが選択されたのと同じ状態にする.

            // 路線名を合わせる
            let roadName = obj.poleMasters[0].road_name
            roadName = roadName.replace('高速', '')
            this.mainStream.send(EVT.SET_ROAD_NAME, { roadName })

            // 地図のエリアごと切り替わる場合はまだ選択すべき点が
            // 表示されてないので実行を後に回すために一旦関数につっこむ
            this.postSetFocusAreaFunc = () => {
              this.mainStream.send(EVT.SELECT_POLES_REV, obj)

              const ids = obj.poleMasters.map(e => e.attached_pole_id)
              const poles = ids.map(id => this.poleMap[id])
              this.poleMasterListStream.emitRecv(EVT.SELECT_POLES, { poles })
            }
            // 路線名が同じ場合は呼ばれないので、自分で一旦呼んどく
            this.postSetFocusAreaFunc()
          } else {
            this.confirmAttachPolesWithPoleMasters(obj)
          }
        })
      this.mainStream.recv(EVT.UNSELECT_POLE_MASTERS,
        (obj) => { this.confirmDetachPolesFromPoleMasters(obj) })
      this.mainStream.recv(EVT.CHANGE_POLES,
        (obj) => { this.onChangePoles(obj) })
      this.mainStream.recv(EVT.CHANGE_ROAD_NAME,
        (obj) => { this.onChangeRoadName(obj) })
      this.mainStream.recv(EVT.SET_FOCUS_AREA,
        (obj) => { this.onSetFocusArea(obj) })
      this.mainStream.recv(EVT.UNSET_FOCUS_AREA,
        (obj) => { this.onUnsetFocusArea(obj) })
    },
    onChangePoles({ poles }) {
      this.displayedPoles = poles
    },
    onChangeRoadName({ roadName }) {
      const map = this.getRoadNameToRoadNameShortMap()
      const roadNameShort = map[roadName]
      if (!roadNameShort) {
        console.error(`roadName=${roadName} not found in map`)
        return
      }
      this.displayedKiloposts = this.kilopostsByRoadNameShort[roadNameShort]
    },
    confirmAttachPolesWithPoleMasters(obj) {
      if (obj.oldPoleMasters && obj.oldPoleMasters.length > 0) {
        this.confirmAttachChangeModalInfo = obj
      } else {
        this.attachPolesWithPoleMasters(obj)
      }
    },
    attachPolesWithPoleMasters(obj) {
      const { poles, poleMasters, oldPoleMasters = [] } =
        obj || this.confirmAttachChangeModalInfo
      // pole_master側にもなんか入れられるようになっているが、
      // それは最後にバッチでやろう.
      // poleだけ更新する.
      const val = poleMasters[0].pole_number
      for (const pole of poles) {
        pole.pole_number = val
        pole.skipUsernameUpdate = true
        poleApi.updatePoleNumber(pole.id, pole).then(() => {
          oldPoleMasters.forEach(e => {
            e.is_attached = false
            e.attached_pole_id = null
          })
          poleMasters.forEach(e => {
            e.is_attached = true
            e.attached_pole_id = pole.id
          })
          this.mainStream.send(EVT.UPDATED_POLES, { poles })
          this.mainStream.send(EVT.UPDATED_POLE_MASTERS,
            { poleMasters: poleMasters.concat(oldPoleMasters) })
          this.confirmAttachChangeModalInfo = null
          this.showUpdateCompleteAlert({
            msg: '紐付けました',
            variant: 'info',
          })
        })
      }
    },
    confirmDetachPolesFromPoleMasters(obj) {
      this.confirmDetachModalInfo = obj
    },
    detachPolesFromPoleMasters() {
      const { poles, poleMasters } = this.confirmDetachModalInfo
      for (const pole of poles) {
        pole.pole_number = ''
        pole.skipUsernameUpdate = true
        poleApi.updatePoleNumber(pole.id, pole).then(() => {
          poleMasters.forEach(e => {
            e.is_attached = false
            e.attached_pole_id = null
          })
          this.mainStream.send(EVT.UPDATED_POLES, { poles })
          this.mainStream.send(EVT.UPDATED_POLE_MASTERS, { poleMasters })
          this.confirmDetachModalInfo = null
          this.showUpdateCompleteAlert({
            msg: '紐付けを解除しました',
            variant: 'warning',
          })
        })
      }
    },
    showUpdateCompleteAlert({ msg, variant }) {
      this.alert.msg = msg
      this.alert.variant = variant
      this.alert.countDown = 1
    },
    onSetFocusArea({ geom }) {
      if (!geom) { return }
      this.focusAreaGeom = geom
      const filteredPoles = []
      for (const pole of this.allPoles) {
        const coords = pole.point.coordinates
        if (geom.intersectsCoordinate(coords)) {
          filteredPoles.push(pole)
        }
      }
      this.filteredPoles = filteredPoles

      if (this.postSetFocusAreaFunc) {
        this.postSetFocusAreaFunc()
        this.postSetFocusAreaFunc = null
      }
    },
  }
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
